<template>
<div class="cx_notification_setting" v-if="item">
  <!-- 棚卸対象外商品の場合は非活性 -->
    <div class="cx_notification_item">
        <span class="description">{{description}}</span>
    　 <toggle-button  v-model="item.enabled" :labels="{checked: 'オン', unchecked: 'オフ'}" :width="55" :font-size="11" color="#7a2e2e" :disabled="enabled == false || isEdit == false"/> 
        <NumericBox  v-if="showDaysBefore && item.enabled" title="送信日" :value.sync="item.daysBefore" :editor="editor" :enabled="enabled" :decimals="0" :min="0" :max="30" :nullValue="0"  suffix="営業日前"/>
        <NumericBox  v-if="showDaysAfter && item.enabled" title="送信日" :value.sync="item.daysAfter" :editor="editor" :enabled="enabled" :decimals="0" :min="0" :max="30" :nullValue="0"  suffix="営業日後"/>   
        <NumericBox  v-if="showBaseDays && item.enabled" title="基準日" :value.sync="item.daysAfter" :editor="editor" :enabled="enabled" :decimals="0" :min="0" :max="999" :nullValue="0"  suffix="日後"/>   
    </div>
    <div class="cx_notification_item" v-if="showSendOptions">
         <CheckBox v-if="item.enabled" title="※追加の送信先" :editor="editor" :value.sync="item.sendOption" :enabled="enabled" :list="sendOption"/>    
    </div>
  </div>
</template>
<script lang="ts">
import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import * as Components from '@/tenant/components';
import * as Common from '@/tenant/common';

@Component
export default class PnlNotificationSetting extends Vue {
  @Prop({ default: null }) public editor: Components.IEditor;
  @Prop({ default: true }) public enabled: boolean;    
  @Prop({ default: null }) public item: Common.NotificationSettings;
  @Prop({ default: null }) public description: boolean;  
  @Prop({ default: false }) public showDaysBefore: boolean;
  @Prop({ default: false }) public showDaysAfter: boolean;
  @Prop({ default: false }) public showBaseDays: boolean;
  @Prop({ default: true }) public showSendOptions: boolean;
  @Prop({ default: false}) public isLimitedOption: boolean;

  public get sendOption(): string {return this.isLimitedOption ? 'sendOptionLimitedFlags' : 'sendOptionFlags'}
  //エディタのバインド
  public isEdit: boolean = true;
  public validator: Components.ControlValidator = null;
  public created() {
    if (this.editor != null) this.editor.addControl(this);
  }
  public destroyed(){
    if (this.editor != null) this.editor.removeControl(this);    
  }  

}
</script>
<style lang="scss">
.cx_notification_setting{
    .cx_notification_item{
        display:flex;
        height: 22px;

        .description{
            width:550px;
            text-align: start;
            font-size:16px;
        }
        .cx_checkbox{
            margin-left:10px;
            color:#8b8b8b;
            .cx_control_caption{
                width:90px !important;
            }
            .cx_control_caption,
            .cx_control_input{
                font-size: 12px !important;
            }            
        }

        .cx_numric_box{
            margin-left: 20px;
            .cx_control_caption{
                width:40px;
            }

            input{
                width:30px;
                min-width: unset;
            }            
            .cx_control_input_read,
            .cx_control_input{
                width:160px;
                min-width: unset;
            }              
            .cx_control_caption,
            .cx_control{
                font-size: 12px !important;
            }
            .cx_control_input{
                height: 36px;
            }
        }

    }

    margin-bottom: 10px;
}
</style>